import { all, call, put, takeLatest } from "redux-saga/effects";
import { Types } from "../../types";
import {
    generateHtmlPreInvoiceToNewlyCustomerRegisteredRequestHandlerRequest,
    getApplicationContractTypeRequest, getCandidateFaxProductsRequest,
    getCandidateIvrProductsRequest, getCandidateSecretaryProducts,
    getCitiesRequest,
    getFreeProposedNumbersRequest, getHtmlPreInvoiceToCustomerRequest,
    getIsFreeProductRequest,
    getPrepareForGatewayRequest,
    getProductNumbersCountRequest,
    getProposedNumbersRequest,
    getPurchaseInfoRequest,
    getSearchFreeProposedNumbersRequest,
    postPurchaseBuyRequest,
    postTryReserveRequestedLinesRequest,
    searchProposedNumbersRequest
} from "../apiRequests/purchaseRequest";
import {
    GetHtmlPreInvoiceToCustomerErrorAction,
    GetHtmlPreInvoiceToCustomerSuccessAction,
    SearchFreeProposeNumberErrorAction,
    SearchFreeProposeNumberSuccessAction,
    generateHtmlPreInvoiceToNewlyCustomerRegisteredErrorAction,
    generateHtmlPreInvoiceToNewlyCustomerRegisteredSuccessAction,
    getApplicationContractTypeErrorAction,
    getApplicationContractTypeSuccessAction,
    getCandidateFaxErrorAction, getCandidateFaxSuccessAction,
    getCandidateIVRErrorAction, getCandidateIVRSuccessAction,
    getCandidateSecretaryErrorAction, getCandidateSecretarySuccessAction,
    getCitiesErrorAction,
    getCitiesSuccessAction,
    getFreeProposedNumbersErrorAction,
    getFreeProposedNumbersSuccessAction,
    getIsFreeProductErrorAction,
    getIsFreeProductSuccessAction,
    getPrepareForGatewayErrorAction,
    getPrepareForGatewaySuccessAction,
    getProductNumbersCountSuccessAction,
    getProposedNumbersErrorAction,
    getProposedNumbersSuccessAction,
    getPurchaseInfoErrorAction,
    getPurchaseInfoSuccessAction,
    postPurchaseBuyErrorAction,
    postPurchaseBuySuccessAction,
    postTryReserveRequestedLinesErrorAction,
    postTryReserveRequestedLinesSuccessAction,
    searchProposedNumbersErrorAction,
    searchProposedNumbersSuccessAction,

} from "../../actions/purchaseActions";
import { City, HtmlPreInvoice, ILine, Line, Package, ProposedNumber } from "../../interfaces/purchase";




function* getFreeProposedNumbersHandler(action: any) {
    try {

        const response: { data: ILine[] } = yield call(getFreeProposedNumbersRequest, action.payload)
        let line = new Line(null);
        line.createLineList(response.data)
        yield put(
            getFreeProposedNumbersSuccessAction(line.lines)
        )


    } catch (error: any) {
        yield put(
            getFreeProposedNumbersErrorAction({
                error: error.message
            })
        )

    }
}


function* getCandidateIVRRequestHandler(action: any) {
    try {

        const response: { data: Package | null } = yield call(getCandidateIvrProductsRequest, action.payload.productId)

        yield put(
            getCandidateIVRSuccessAction(response.data)
        )
        // action.payload.callback(response.token)

    } catch (error: any) {
        yield put(
            getCandidateIVRErrorAction({
                error: error.message
            })
        )

    }
}


function* getCandidateSecretaryRequestHandler(action: any) {
    try {
        const response: { data: Package | null } = yield call(getCandidateSecretaryProducts, action.payload.productId)

        yield put(
            getCandidateSecretarySuccessAction(response.data)
        )
        // action.payload.callback(response.token)

    } catch (error: any) {
        yield put(
            getCandidateSecretaryErrorAction({
                error: error.message
            })
        )

    }
}


function* getCandidateFaxRequestHandler(action: any) {
    try {
        const response: { data: Package | null } = yield call(getCandidateFaxProductsRequest, action.payload.productId)

        yield put(
            getCandidateFaxSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            getCandidateFaxErrorAction({
                error: error.message
            })
        )

    }
}


function* getProductNumbersCountRequestHandler(action: any) {
    try {

        const response: { data: number | null } = yield call(getProductNumbersCountRequest, action.payload.productId)

        yield put(
            getProductNumbersCountSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            getCandidateFaxErrorAction({
                error: error.message
            })
        )

    }
}


function* getApplicationContractTypeRequestHandler(action: any) {
    try {

        const response: { data: any | null } = yield call(getApplicationContractTypeRequest, action.payload.productId)

        yield put(
            getApplicationContractTypeSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            getApplicationContractTypeErrorAction({
                error: error.message
            })
        )

    }
}


function* getHTMLPreInvoiceRequestHandler(action: any) {
    try {

        const response: { data: any | null } = yield call(getHtmlPreInvoiceToCustomerRequest, action.payload)
        let htmlPreInvoice = new HtmlPreInvoice(response.data);

        yield put(
            GetHtmlPreInvoiceToCustomerSuccessAction(htmlPreInvoice)
        )

    } catch (error: any) {
        yield put(
            GetHtmlPreInvoiceToCustomerErrorAction({
                error: error
            })
        )

    }
}


function* searchFreeProposedNumbersRequestHandler(action: any) {
    try {

        const response: { data: Line[] | null } = yield call(getSearchFreeProposedNumbersRequest, action.payload)

        yield put(
            SearchFreeProposeNumberSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            SearchFreeProposeNumberErrorAction({
                error: error.message
            })
        )

    }
}


function* getPrepareForGatewayRequestHandler(action: any) {
    try {

        const response: { data: any | null } = yield call(getPrepareForGatewayRequest, action.payload)

        yield put(
            getPrepareForGatewaySuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            getPrepareForGatewayErrorAction({
                error: error.message
            })
        )

    }
}


function* postTryReserveRequestedLinesRequestHandler(action: any) {
    try {

        const response: { data: any | null } = yield call(postTryReserveRequestedLinesRequest, action.payload)

        yield put(
            postTryReserveRequestedLinesSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            postTryReserveRequestedLinesErrorAction({
                error: error.message
            })
        )

    }
}


function* postPurchaseBuyRequestHandler(action: any) {
    try {
        const response: { data: any | null } = yield call(postPurchaseBuyRequest, action.payload)
        yield put(
            postPurchaseBuySuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            postPurchaseBuyErrorAction({
                error: error.message
            })
        )

    }
}



function* getPurchaseInfoRequestHandler(action: any) {
    try {

        const response: { data: any | null } = yield call(getPurchaseInfoRequest, action.payload)

        yield put(
            getPurchaseInfoSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            getPurchaseInfoErrorAction({
                error: error.message
            })
        )

    }
}


function* getProposedNumbersRequestHandler(action: any) {
    try {

        const response: { data: ProposedNumber[] | null } = yield call(getProposedNumbersRequest, action.payload)

        yield put(
            getProposedNumbersSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            getProposedNumbersErrorAction({
                error: error.message
            })
        )

    }
}



function* searchProposedNumberRequestHandler(action: any) {
    try {

        const response: { data: ProposedNumber[] | null } = yield call(searchProposedNumbersRequest, action.payload)

        yield put(
            searchProposedNumbersSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            searchProposedNumbersErrorAction({
                error: error.message
            })
        )

    }
}


function* getCitiesRequestHandler() {
    try {

        const response: { data: City[] | null } = yield call(getCitiesRequest)

        yield put(
            getCitiesSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            getCitiesErrorAction({
                error: error.message
            })
        )

    }
}


function* getIsFreeProductRequestHandler(action: any) {
    try {

        const response: { data: boolean } = yield call(getIsFreeProductRequest, action.payload)

        yield put(
            getIsFreeProductSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            getIsFreeProductErrorAction({
                error: error.message
            })
        )

    }
}

function* generateHtmlPreInvoiceToNewlyCustomerRegisteredRequestHandler(action: any) {
    try {

        const response: { data: any } = yield call(generateHtmlPreInvoiceToNewlyCustomerRegisteredRequestHandlerRequest, action.payload)

        yield put(
            generateHtmlPreInvoiceToNewlyCustomerRegisteredSuccessAction(response.data)
        )

    } catch (error: any) {

        yield put(
            generateHtmlPreInvoiceToNewlyCustomerRegisteredErrorAction({
                error: typeof error === 'string' ? error : error.message
            })
        )

    }
}

function* purchaseSaga() {
    yield all([takeLatest(Types.SELECT_PACKAGE_REQUEST, getFreeProposedNumbersHandler)]);
    yield all([takeLatest(Types.GET_CANDIDATE_IVR_PRODUCT_REQUEST, getCandidateIVRRequestHandler)]);
    yield all([takeLatest(Types.GET_CANDIDATE_SECRETARY_PRODUCT_REQUEST, getCandidateSecretaryRequestHandler)]);
    yield all([takeLatest(Types.GET_CANDIDATE_FAX_PRODUCT_REQUEST, getCandidateFaxRequestHandler)]);
    yield all([takeLatest(Types.GET_PRODUCT_NUMBERS_COUNT_REQUEST, getProductNumbersCountRequestHandler)]);
    yield all([takeLatest(Types.GET_APPLICATION_CONTRACT_TYPE_REQUEST, getApplicationContractTypeRequestHandler)]);
    yield all([takeLatest(Types.GEN_HTML_PRE_INVOICE_TO_CUSTOMER_REQUEST, getHTMLPreInvoiceRequestHandler)]);
    yield all([takeLatest(Types.SEARCH_FREE_PROPOSE_NUMBER_REQUEST, searchFreeProposedNumbersRequestHandler)]);
    yield all([takeLatest(Types.GET_PREPARE_FOR_GATEWAY_REQUEST, getPrepareForGatewayRequestHandler)]);
    yield all([takeLatest(Types.POST_TRY_RESERVE_LINE_REQUEST, postTryReserveRequestedLinesRequestHandler)]);
    yield all([takeLatest(Types.POST_PURCHASE_BUY_REQUEST, postPurchaseBuyRequestHandler)]);
    yield all([takeLatest(Types.GET_PURCHASE_INFO_REQUEST, getPurchaseInfoRequestHandler)]);
    yield all([takeLatest(Types.GET_PROPOSED_NUMBERS_REQUEST, getProposedNumbersRequestHandler)]);
    yield all([takeLatest(Types.SEARCH_PROPOSED_NUMBERS_REQUEST, searchProposedNumberRequestHandler)]);
    yield all([takeLatest(Types.GET_CITIES_REQUEST, getCitiesRequestHandler)]);
    yield all([takeLatest(Types.GET_IS_FREE_PRODUCT_REQUEST, getIsFreeProductRequestHandler)]);
    yield all([takeLatest(Types.GEN_HTML_PRE_INVOICE_NEWLY_REGISTER_CUSTOMER_REQUEST, generateHtmlPreInvoiceToNewlyCustomerRegisteredRequestHandler)]);




}

export default purchaseSaga